/**
 * カテゴリ種別
 */
export const CategoryKind = {
  /** TOP */
  INDEX: 0,
  /** 初めてガイド */
  FIRST: 1,
  /** ご利用ガイド */
  GUIDE: 2,
  /** 管理職機能 */
  MANAGE: 3,
  /** マニュアル動画 */
  MOVIE: 6,
  /** 各種設定 */
  SETTING: 4,
  /** よくあるご質問 */
  FAQ: 5,
} as const
export type CategoryKindType = typeof CategoryKind[keyof typeof CategoryKind]
